import React, { FC, useCallback, useMemo } from 'react';
import { observer } from "mobx-react-lite";
import moveArrowBlue from "../../../assets/MoveArrowBlue.svg";
import moveArrowGray from "../../../assets/Arrow_Sub_Right_Down.svg";
import { AppContext } from "../../../App";

export interface IMoveButtonProps {
    onClickFunc: () => void;
    permission: boolean;
}

const BtnMove: FC<IMoveButtonProps> = ({ onClickFunc, permission }) => {
    const { showToast } = React.useContext(AppContext);

    const buttonIcon = useMemo(() => 
        permission ? moveArrowBlue : moveArrowGray, 
        [permission]
    );

    const handleClick = useCallback(() => {
        if (permission) {
            onClickFunc();
        } else {
            showToast("У вас нет прав для передвижения задач(и)!");
        }
    }, [permission, onClickFunc, showToast]);

    return (
        <div className="button-base" onClick={handleClick}>
            <img 
                src={buttonIcon} 
                alt="Move" 
                title={permission ? "Переместить задачи" : "Нет прав для перемещения"}
            />
        </div>
    );
};

export default observer(BtnMove);